import ProfileApi from '@/api/account/customer/profile-api';
import AuthApi from '@/api/account/auth/auth-api';


export const profileApi = new ProfileApi();
export const authApi = new AuthApi();
